import * as ss from 'superstruct';
import { Id } from '../../types';

export const FunnelStageResource = ss.type({
  id: Id,
  /** Name of the stage. */
  name: ss.string(),
  /** Stages are ranked in ascending order. */
  rank: ss.integer(),
});

export type FunnelStageResource = ss.Infer<typeof FunnelStageResource>;
